export const dashboardConstants = {
    GET_DASHBOARD_REQUEST:   'GET_DASHBOARD_REQUEST',
    GET_DASHBOARD_SUCCESS:   'GET_DASHBOARD_SUCCESS',
    GET_DASHBOARD_FAILURE:   'GET_DASHBOARD_FAILURE',
};
